import React from 'react';
import Paper from '@mui/material/Paper';
import './Styles.css'
import {
  DataGrid,
  GridFooterContainer,
  GridPagination,
  GridToolbar
} from '@mui/x-data-grid';
import { Box, styled, Typography } from '@mui/material';
import { CONST_SITE_LABEL } from './Helper';

/**
 * Custom Data Grid Table component
 * The component is mainly used in Optimization component
 * @param {*} props 
 * @returns 
 */
const DataGridTable = (props) => {
  // const [page, setPage] = useState(0);
  // const [rowsPerPage, setRowsPerPage] = useState(10);
  // const [orderBy, setOrderBy] = useState('');
  // const [sortDirection, setSortDirection] = useState('asc');

  const columns = props.columns ?? []
  const rows = props.rows ?? []
  const showCustomToolbar = props.showCustomToolbar ?? false;
  const rowHeight = props.rowHeight ?? undefined
  const autoHeight = props.autoHeight ?? false
  const headerBgColor = props.headerBgColor ?? '#203B5A'
  const evenRowBgColor = props.evenRowBgColor ?? '#E6EAED'
  const oddRowColor = props.oddRowColor ?? '#000'
  const evenRowColor = props.evenRowColor ?? '#000'
  const iconColor = props.actionIconColor ?? '#2793F2'
  const hideExport = props.hideExport ?? false
  // const showTooltip = props.showTooltip
  // const showPagination = props.showPagination ?? true

  // const handleChangePage = (_, newPage) => setPage(newPage);
  // const handleChangeRowsPerPage = (event) => {
  //   setRowsPerPage(+event.target.value);
  //   setPage(0);
  // };

  // const handleRequestSort = (property) => {
  //   const isAsc = orderBy === property && sortDirection === 'asc';
  //   setOrderBy(property);
  //   setSortDirection(isAsc ? 'desc' : 'asc');
  // };

  const StyledDataGrid = styled(DataGrid)(({ theme }) => ({
    '&.MuiDataGrid-root': {
      backgroundColor: props.bgColor ?? '#F6FBFF',
    },
    '& .MuiDataGrid-row:nth-of-type(odd)': {
      color: oddRowColor
    },
    '& .MuiDataGrid-row:nth-of-type(even)': {
      backgroundColor: evenRowBgColor,
      color: evenRowColor
    },
    '& .MuiButton-text': {
      color: '#000'
    },
    '& .MuiButton-text .MuiSvgIcon-root': {
      color: iconColor
    },
    '& .MuiDataGrid-toolbarContainer': {
      alignSelf: 'end'
    },
    '& .MuiDataGrid-columnHeader': {
      backgroundColor: headerBgColor,
      color: '#fff',
      fontWeight: '600'
    },
    // Apply custom sx prop styles if provided
    ...(props.sx && typeof props.sx === 'object' ? props.sx : {})
  }));

  /**
   * Returns CSV filename
   * @returns 
   */
  const generateExportFileName = () => {
    const path = window.location.pathname
    const splitPath = path.split('/')
    return `${CONST_SITE_LABEL}_Optimization_${splitPath[splitPath.length - 1]?.toUpperCase()}`
  }

  /**
   * Custom Footer Component
   * @param {*} props 
   * @returns 
   */
  const CustomFooterComponent = (props) => {
    return (
      <GridFooterContainer>
        <div>{props['customFooterEl']}</div>
        <GridPagination />
      </GridFooterContainer>
    )
  }

  const NoRowsOverlay = () => {
    return (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100%',
          width: '100%',
        }}
      >
        <Typography variant="h6" color="textSecondary">
          No Data Found
        </Typography>
      </Box>
    );
  }

  return (
    <Paper sx={{ width: '100%' }}>
      <div style={{
        // maxHeight: 440, 
        // minWidth: 400,
        minWidth: 'auto',
        // overflow: 'auto'
      }}>
        <StyledDataGrid
          {...(rowHeight !== undefined ? { rowHeight } : {})}
          {...(autoHeight ? { autoHeight: true } : {})}
          slots={{
            
            noRowsOverlay: props['subscribeOverlayComponent'] ?? NoRowsOverlay,
            footer: CustomFooterComponent
          }}
          className='optimization-data-grid'
          columns={columns}
          rows={rows}
          slotProps={{
            toolbar: {
              csvOptions: { fileName: generateExportFileName(), disableToolbarButton: hideExport },
              printOptions: {disableToolbarButton: hideExport}
            },
            footer: { customFooterEl: props['customFooterEl'] }
          }}
          initialState={{
            columns: {
              columnVisibilityModel: props['columnVisibilityModel']
            }
          }}
        />
      </div>

    </Paper>
  );
};

export default DataGridTable;
